/**
 * 异常处理
 * @static
 * @param {*} message   错误消息
 */
export function throwError(message: string) {
    throw new Error(message);
}
